import PropTypes from 'prop-types';
import React from 'react';
import GeneralPopup, { PopupTypes } from '../GeneralPopup';

const translationPrefix = 'STATIC.NAVIGATION_BLOCKER';

const ConfirmChangesDialog = ({
    open = false,
    onAccept = () => {},
    onReject = () => {},
    title = `${translationPrefix}.TITLE`,
    text = `${translationPrefix}.MESSAGE`,
    acceptText = `${translationPrefix}.ACCEPT_BUTTON_TEXT`,
    rejectText = `${translationPrefix}.REJECT_BUTTON_TEXT`,
}) => (
    <GeneralPopup
        open={open}
        type={PopupTypes.WARNING_WITH_CANCEL}
        title={title}
        text={text}
        acceptText={acceptText}
        rejectText={rejectText}
        onAccept={onAccept}
        onReject={onReject}
    />
);

ConfirmChangesDialog.propTypes = {
    open: PropTypes.bool,
    onAccept: PropTypes.func,
    onReject: PropTypes.func,
    title: PropTypes.string,
    text: PropTypes.string,
    acceptText: PropTypes.string,
    rejectText: PropTypes.string,
};

export default ConfirmChangesDialog;
